export const transformFilters = (filters: Record<string, unknown>) => {
  const result: Record<string, unknown> = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      result[key] = value.length > 0 ? value : undefined;
    } else {
      result[key] = value;
    }
  });

  return result;
};
